export default {
  socialNetworks: 'Redes sociales',
  sentEmails: 'Emails enviados',
  peoplePerDay: 'Personas por día',
  peoplePerMonth: 'Personas por mes',
  statsPerApp: 'Estadísticas por aplicación',
  search: 'Buscar',
  name: 'Nombre',
  people: 'Contacts',
  person: 'Persona',
  sentMessages: 'Mensajes enviados',
  messagesParts: 'Partes de mensajes',
  applicationsPerPage: 'Aplicaciones por página',
  cellphoneRecords: 'Registros con celular',
  totalRecords: 'Registros totales',
  noName: 'Sin nombre',
  noJourneyId: 'Sin ID',
  noAppsToShow: 'No hay aplicaciones para mostrar',
  manualPayment: 'Pago manual',
  manualCollection: 'Cobro manual',
  noDataYet: 'No hay datos por el momento'
}
